<template>
    <div v-if="filtered" class="text-black dark:text-white">
        <div v-if="!!items.length">
            <input type="text" v-model="search" class="block bg-white text-black dark:bg-gray-700 dark:text-white w-full border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 mt-1 disabled:opacity-50 rounded-b-none shadow border-0 border-b" placeholder="Search...">
            <ul class="text-center rounded-lg shadow-inner divide-y bg-white dark:bg-gray-700 max-h-64 overflow-auto rounded-t-none">
                <li :class="itemStyles(item)" class="py-2 text-center cursor-pointer" @click="() => selectItem(item)" v-for="item in filteredItems" :key="item.id">
                    {{ item.name }}
                </li>
            </ul>
            <p class="text-xs mt-2">{{ selectedItems.length }} selected out of {{ items.length }} casinos with published reviews
            <label class="items-center float-right">
                <input
                    @click="() => selectAll()"
                    type="checkbox"
                    class="form-checkbox"
                />
                <span class="ml-2">{{ allCasinosSelected ? 'Unselect all' : 'Select ' + this.maxValue }}</span>
            </label>
            </p>
        </div>
        <div v-if="!items.length" class="w-full mx-auto mt-5 border-2 border-dashed rounded py-3 px-4">
            <p class="text-2xl text-gray-400 text-center">No casinos found!</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "RankingsList",
    props: {
        items: {
            type: Array,
            required: true
        },
        value: Array,
        filtered: Boolean,
        maxValue: Number,
    },
    data(){
        return {
            selectedItems: this.value,
            search: "",
            allCasinosSelected: false
        }
    },
    methods: {
        selectItem(item){
            if(this.itemIsSelected(item)) {
                this.removeItem(item);
            } else {
                if (this.selectedItems.length < this.maxValue) {
                    this.selectedItems.push(item);
                }
            }
            this.$emit('input', this.selectedItems)
        },
        selectAll(){
            if (this.allCasinosSelected) {
                 this.selectedItems = [];
            } else {
                this.selectedItems = this.filteredItems.slice(0, this.maxValue);
            }
            this.allCasinosSelected = !this.allCasinosSelected;
            this.$emit('input', this.selectedItems);
        },
        itemIsSelected(item){
            const slimSelectedItems = this.selectedItems.map(item => item.id);
            return !!slimSelectedItems.includes(item.id);
        },
        removeItem(item){
            const slimSelectedItems = this.selectedItems.map(item => item.id);
            const index = slimSelectedItems.indexOf(item.id);
            this.selectedItems.splice(index, 1);
        },
        itemStyles(item){
            const selected = this.itemIsSelected(item)
            if(selected) {
                return [
                   'bg-indigo-200 dark:bg-indigo-500 font-semibold'
                ]
            }
        }
    },
    computed:{
        filteredItems(){
            if(!this.search.length) return this.items;
            return this.items.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()));
        }
    }
}
</script>
